<template>
  <div>
    <button :class="{'primary': primary, 'secondary': secondary}" :style="cssObject" @click="buttonClick">
      <slot></slot>
    </button>
  </div>
</template>

<script>
  export default {
    name: 'smart-button',
    props: ['cssObject', 'type'],
    data() {
      return {
        primary: false,
        secondary: false
      }
    },
    methods: {
      buttonClick() {
        this.$emit('onClick')
      }
    },
    watch: {
      type(value) {
        if (value === 'primary') {
          this.primary = true
          this.secondary = false
        } else if (this.type === 'secondary') {
          this.secondary = true
          this.primary = false
        }
      }
    },
    created() {
      if (this.type === 'primary') {
        this.primary = true
      } else if (this.type === 'secondary') {
        this.secondary = true
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../../src/styles/breakpoints';
  @import '../../../../src/styles/colours';

  .primary {
    color: white;
    background-color: $light-blue;
    border-radius: 2px;
    box-shadow: 0 1px 3px 0 $drop-shadow-black;
    border: solid 2.8px $light-blue;
    font-size: 18px;
    font-weight: bold;

    &:hover {
      box-shadow: 3px 5px 8px 0 $drop-shadow-black;
      border: solid 2.8px white;
      background-color: white;
      color: $light-blue;
    }
  }

  .secondary {
    color: white;
    background-color: white;
    border-radius: 2px;
    box-shadow: 0 1px 3px 0 $drop-shadow-black;
    border: solid 2.8px $light-blue;
    font-size: 18px;
    font-weight: bold;
    color: $light-blue;

    &:hover {
      box-shadow: 3px 5px 8px 0 $drop-shadow-black;
      border: solid 2.8px $light-blue;
      background-color: $light-blue;
      color: white;
    }
  }

</style>
